import { render, staticRenderFns } from "./UserMagicToken.vue?vue&type=template&id=7eb003f4&scoped=true"
import script from "./UserMagicToken.vue?vue&type=script&lang=js"
export * from "./UserMagicToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb003f4",
  null
  
)

export default component.exports